import { Box, Fade, Hidden } from '@mui/material'
import React from 'react'
import Carousel from 'react-material-ui-carousel'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { NivosLogin, NivosRegister } from 'components/landing-page'
import { API_ACCESS_KEY } from 'constants/common'
import image2 from 'images/demo2.png'
import image3 from 'images/demo3.png'
import image4 from 'images/demo4.png'
import image1 from 'images/demo.jpeg'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { get, mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
  }
}

type AppProps = StateProps & DispatchProps

const LandingPageFC: React.FC<any> = (props: AppProps) => {
  const { theme, user, operations } = props
  const [register, setRegister] = React.useState(false)
  const navigator = useNavigate()

  React.useEffect(() => {
    if (localStorage.getItem(API_ACCESS_KEY) === null) {
      operations.user.set({ ...user, authenticated: false })
      navigator('/')
    } else if (localStorage.getItem(API_ACCESS_KEY) !== null && user.id === 0) {
      void get('/account/profile/').then(profileData => {
        if (profileData.length > 0) {
          const userData = {
            ...profileData[0],
            authenticated: true
          }
          operations.user.set(userData)
        }
      })
    }
  }, [])

  return (
    <Fade in={true} timeout={1000}>
      <Box display={'flex'} width={'100vw'} height={'100vh'}>
        <Hidden mdDown>
          <Box height={1} width={0.75}>
            <Carousel
              navButtonsAlwaysInvisible
              autoPlay={true}
              cycleNavigation={true}
              sx={{ width: '100%', height: '100%' }}
              animation={'fade'}
              indicators={false}
              duration={2500}
              interval={5000}
            >
              <Box
                minHeight={'100vh'}
                minWidth={'100%'}
                sx={{
                  backgroundImage: `url(${image4 as string})`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center'
                }}
              />
              <Box
                minHeight={'100vh'}
                minWidth={'100%'}
                sx={{
                  backgroundImage: `url(${image1 as string})`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center'
                }}
              />
              <Box
                minHeight={'100vh'}
                minWidth={'100%'}
                sx={{
                  backgroundImage: `url(${image2 as string})`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center'
                }}
              />
              <Box
                minHeight={'100vh'}
                minWidth={'100%'}
                sx={{
                  backgroundImage: `url(${image3 as string})`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center'
                }}
              />
            </Carousel>
          </Box>
        </Hidden>
        <Box
          bgcolor={theme.primaryColor}
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          justifyContent={'center'}
          height={1}
          flexGrow={1}
        >
          <NivosLogin openRegister={register} setOpenRegister={setRegister} />
          <NivosRegister
            openRegister={register}
            setOpenRegister={setRegister}
          />
        </Box>
      </Box>
    </Fade>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations
})

const LandingPage = connect(mapStateToProps, mapDispatchToProps)(LandingPageFC)

export default LandingPage
